export default __webpack_public_path__ + "static/media/icon_2_on.9e987e6b.png";